export interface CancelOrdersRequest {
  orders: {
    id: number
    revision: number
  }[]
}

export function CancelOrderRequestToJSON(value: CancelOrdersRequest): any {
  return {
    orders:
      value.orders.length > 0
        ? value.orders.map(order => {
            return {
              id: order.id !== 0 ? order.id : undefined,
              revision: order.revision !== 0 ? order.revision : undefined
            }
          })
        : undefined
  }
}
